// characters.js
// Holds all character codes and other definitions for character code page

export default {
	searchString: "",
	// Character code object
	characters: [
		{
			name: "exclamation point",
			css: "21",
			htmlNumber: "33",
			character: "!",
		},
		{
			name: "double quotes",
			css: "22",
			htmlNumber: "34",
			htmlName: "quot",
			character: "xxxxxx",
		},
		{
			name: "number sign",
			css: "23",
			htmlNumber: "35",
			character: "#",
		},
		{
			name: "dollar sign",
			css: "24",
			htmlNumber: "36",
			character: "$",
		},
		{
			name: "percent sign",
			css: "25",
			htmlNumber: "37",
			character: "%",
		},
		{
			name: "ampersand",
			css: "26",
			htmlNumber: "38",
			htmlName: "amp",
			character: "&",
		},
		{
			name: "single quote",
			css: "27",
			htmlNumber: "39",
			character: "'",
		},
		{
			name: "opening parenthesis",
			css: "28",
			htmlNumber: "40",
			character: "(",
		},
		{
			name: "closing parenthesis",
			css: "29",
			htmlNumber: "41",
			character: ")",
		},
		{
			name: "asterisk",
			css: "2A",
			htmlNumber: "42",
			character: "*",
		},
		{
			name: "plus sign",
			css: "2B",
			htmlNumber: "43",
			character: "+",
		},
		{
			name: "comma",
			css: "2C",
			htmlNumber: "44",
			character: ",",
		},
		{
			name: "minus / hyphen",
			css: "2D",
			htmlNumber: "45",
			character: "-",
		},
		{
			name: "period",
			css: "2E",
			htmlNumber: "46",
			character: ".",
		},
		{
			name: "slash",
			css: "2F",
			htmlNumber: "47",
			character: "/",
		},
		{
			name: "colon",
			css: "3A",
			htmlNumber: "58",
			character: ":",
		},
		{
			name: "semicolon",
			css: "3B",
			htmlNumber: "59",
			character: ";",
		},
		{
			name: "less than sign",
			css: "3C",
			htmlNumber: "60",
			htmlName: "lt",
			character: "<",
		},
		{
			name: "equal sign",
			css: "3D",
			htmlNumber: "61",
			character: "=",
		},
		{
			name: "greater than sign",
			css: "3E",
			htmlNumber: "62",
			htmlName: "gt",
			character: ">",
		},
		{
			name: "question mark",
			css: "3F",
			htmlNumber: "63",
			character: "?",
		},
		{
			name: "at symbol",
			css: "40",
			htmlNumber: "64",
			character: "@",
		},
		{
			name: "opening bracket",
			css: "5B",
			htmlNumber: "91",
			character: "[",
		},
		{
			name: "backslash",
			css: "5C",
			htmlNumber: "92",
			character: "\\",
		},
		{
			name: "closing bracket",
			css: "5D",
			htmlNumber: "93",
			character: "]",
		},
		{
			name: "caret - circumflex",
			css: "5E",
			htmlNumber: "94",
			character: "^",
		},
		{
			name: "underscore",
			css: "5F",
			htmlNumber: "95",
			character: "_",
		},
		{
			name: "grave accent",
			css: "60",
			htmlNumber: "96",
			character: "`",
		},
		{
			name: "opening brace",
			css: "7B",
			htmlNumber: "123",
			character: "{",
		},
		{
			name: "vertical bar",
			css: "7C",
			htmlNumber: "124",
			character: "|",
		},
		{
			name: "closing brace",
			css: "7D",
			htmlNumber: "125",
			character: "}",
		},
		{
			name: "equivalency / tilde",
			css: "7E",
			htmlNumber: "126",
			character: "~",
		},
		{
			name: "non-breaking space",
			css: "A0",
			htmlNumber: "160",
			htmlName: "nbsp",
			character: " ",
		},
		{
			name: "inverted exclamation",
			css: "A1",
			htmlNumber: "161",
			htmlName: "iexcl",
			character: "¡",
		},
		{
			name: "cent",
			css: "A2",
			htmlNumber: "162",
			htmlName: "cent",
			character: "¢",
		},
		{
			name: "pound",
			css: "A3",
			htmlNumber: "163",
			htmlName: "pound",
			character: "£",
		},
		{
			name: "currency",
			css: "A4",
			htmlNumber: "164",
			htmlName: "curren",
			character: "¤",
		},
		{
			name: "yen",
			css: "A5",
			htmlNumber: "165",
			htmlName: "yen",
			character: "¥",
		},
		{
			name: "broken vertical bar",
			css: "A6",
			htmlNumber: "166",
			htmlName: "brvbar",
			character: "¦",
		},
		{
			name: "section",
			css: "A7",
			htmlNumber: "167",
			htmlName: "sect",
			character: "xxxxxx",
		},
		{
			name: "spacing diaeresis - umlaut",
			css: "A8",
			htmlNumber: "168",
			htmlName: "uml",
			character: "¨",
		},
		{
			name: "copyright",
			css: "A9",
			htmlNumber: "169",
			htmlName: "copy",
			character: "xxxxxx",
		},
		{
			name: "feminine ordinal",
			css: "AA",
			htmlNumber: "170",
			htmlName: "ordf",
			character: "ª",
		},
		{
			name: "masculine ordinal",
			css: "BA",
			htmlNumber: "186",
			htmlName: "ordm",
			character: "º",
		},
		{
			name: "left double angle",
			css: "AB",
			htmlNumber: "171",
			htmlName: "laquo",
			character: "«",
		},
		{
			name: "not sign",
			css: "AC",
			htmlNumber: "172",
			htmlName: "not",
			character: "¬",
		},
		{
			name: "registered trade mark",
			css: "AE",
			htmlNumber: "174",
			htmlName: "reg",
			character: "®",
		},
		{
			name: "macron - overline",
			css: "AF",
			htmlNumber: "175",
			htmlName: "macr",
			character: "¯",
		},
		{
			name: "degree",
			css: "B0",
			htmlNumber: "176",
			htmlName: "deg",
			character: "°",
		},
		{
			name: "plus-or-minus",
			css: "B1",
			htmlNumber: "177",
			htmlName: "plusmn",
			character: "±",
		},
		{
			name: "superscript - one",
			css: "B9",
			htmlNumber: "185",
			htmlName: "sup1",
			character: "¹",
		},
		{
			name: "superscript - squared",
			css: "B2",
			htmlNumber: "178",
			htmlName: "sup2",
			character: "²",
		},
		{
			name: "superscript - cubed",
			css: "B3",
			htmlNumber: "179",
			htmlName: "sup3",
			character: "³",
		},
		{
			name: "micro",
			css: "B5",
			htmlNumber: "181",
			htmlName: "micro",
			character: "µ",
		},
		{
			name: "pilcrow - paragraph",
			css: "B6",
			htmlNumber: "182",
			htmlName: "para",
			character: "¶",
		},
		{
			name: "middle dot",
			css: "B7",
			htmlNumber: "183",
			htmlName: "middot",
			character: "·",
		},
		{
			name: "per thousand sign",
			css: "2030",
			htmlNumber: "8240",
			character: "‰",
		},
		{
			name: "fraction one quarter",
			css: "BC",
			htmlNumber: "188",
			htmlName: "frac14",
			character: "¼",
		},
		{
			name: "fraction one half",
			css: "BD",
			htmlNumber: "189",
			htmlName: "frac12",
			character: "½",
		},
		{
			name: "fraction three quarters",
			css: "BE",
			htmlNumber: "190",
			htmlName: "frac34",
			character: "¾",
		},
		{
			name: "inverted question",
			css: "BF",
			htmlNumber: "191",
			htmlName: "iquest",
			character: "iquest",
		},
		{
			name: "multiplication",
			css: "D7",
			htmlNumber: "215",
			htmlName: "times",
			character: "×",
		},
		{
			name: "en dash",
			css: "2013",
			htmlNumber: "8211",
			character: "–",
		},
		{
			name: "em dash",
			css: "2014",
			htmlNumber: "8212",
			character: "—",
		},
		{
			name: "dagger",
			css: " 2020",
			htmlNumber: "8224",
			character: "†",
		},
		{
			name: "double dagger",
			css: "2021",
			htmlNumber: "8225",
			character: "‡",
		},
		{
			name: "bullet",
			css: "2022",
			htmlNumber: "8226",
			character: "•",
		},
		{
			name: "horizontal ellipsis",
			css: "2026",
			htmlNumber: "8230",
			character: "…",
		},
		{
			name: "euro sign",
			css: "20AC",
			htmlNumber: "8364",
			htmlName: "euro",
			character: "€",
		},
		{
			name: "trade mark",
			css: "2122",
			htmlNumber: "8482",
			character: "™",
		},
		// {
		// 	name: "xxxxxx",
		// 	css: "xxxxxx",
		// 	htmlNumber: "xxxxxx",
		// 	htmlName: "xxxxxx",
		// 	character: "xxxxxx",
		// },
	]
}
